import type { SvgIconProps } from '@mui/material/SvgIcon'
import SvgIcon from '@mui/material/SvgIcon'

/** Remix Icon `notification-2-line` (RemixIcon, MIT) — matches dev handoff bell glyph. */
export function NotificationBellGlyph(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize="inherit" aria-hidden {...props}>
      <path d="M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z" />
    </SvgIcon>
  )
}
